import { CartItemContainer, ItemDetails} from './cart-item.styles.js'

const CartItem = ({cartItem}) => {

    const { name, quantity, imageUrl, price } = cartItem;

    return(
        <CartItemContainer >
            <img src={imageUrl} alt={name} />
            <ItemDetails>
                <span>{name}</span>
                <span>{quantity} x ${price}</span> 
            </ItemDetails>
        </CartItemContainer>
    )
};

export default CartItem